<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {
    this.$store.dispatch("lookups/getLookups");
    this.$store.dispatch("lookups/getDepartments");

  },
  computed: {
    medicineTypes() {
      return [
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.MedicineTypes
        )];
    },
    units() {
      return [
        ...this.$store.getters["lookups/getLookupByType"](
          this.$lookupTypes.UnitTypes
        )];
    },
    departments() {
      return this.$store.state.lookups.departments;

    }

  },
  data() {
    return {
      vm: {
        medicineName: null,
        medicineTypeId: null,
        unitId: null,
        dosage: null,
        description: null,
        departmentId: null,

      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("medicines/add", this.vm)
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },

    back() {
      this.$emit("back");
    },
  },
};
</script>